import styled from '@emotion/styled'
import { BackdropModal } from '@helpers/styles'
import { Theme } from '@mui/material'

const BackdropWithModalStyles = styled(BackdropModal)`
	.add-product-section-title {
		color: #cdcdcd;
		font-size: 1rem;
	}

	.add-product-form-label {
		color: #6f6f6f;
		font-size: 0.875rem;
	}

	.add-product-form-input {
		margin-bottom: 16px;
	}

	}
`

const LoadingContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 100;
`

const ContentContainer = styled.div<{ $isOpaque?: boolean }>`
	display: flex;
	justify-content: center;
	opacity: ${({ $isOpaque }) => ($isOpaque ? 0.2 : 1)};
`

const Header = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px;
	${({ theme }) => `
        border-bottom: 1px solid ${theme.palette.borderColors.lightGrey};
    `}
	margin-bottom: 50px;
`

const Footer = styled.div`
	display: flex;
	justify-content: space-between;
	${({ theme }: { theme: Theme }) => `
        border-top: 1px solid ${theme.palette.borderColors.lightGrey};
        gap: ${theme.spacing(2)};
    `}
	padding: 20px;
	width: 100%;
	margin-top: 50px;
`

export {
	BackdropWithModalStyles,
	ContentContainer,
	Footer,
	Header,
	LoadingContainer,
}
